import { CountryCodes } from "../../../types/amazonAds"

export enum DisplayProjects {
  TABLE = "table",
  LIST = "list",
}

export interface IAsin {
  asin: string
  isPrimary: boolean
  imageUrl: string
  title: string
  price: string
}

export interface IProject {
  _id: string
  title: string
  asins: IAsin[]
  countryCode: CountryCodes
  campaignIds: string[]
  keywords: string[]
}

export interface ICreateProject {
  countryCode: CountryCodes
  title: string
  asins: string[]
  keywords: string[]
}
